module.exports = __webpack_public_path__ + "img/benefit-icon_pen.86123eaa.svg";